import React from 'react';
import classNames from 'classnames';

import './styles.css';

export default class Person extends React.Component {
  render() {
    const {
      name,
      fullName,
      phone,
      phoneDisplay,
      email,
    } = this.props

    const personClasses = classNames({
      'Person-image': true,
      [`Person__${name}`]: true,
    })

    return (
      <div className="Person">
        <div className={personClasses}></div>
        <div className="Person-info">
          <p className="Person-paragraph Paragraph">{fullName}</p>
          <p className="Person-paragraph Paragraph">
            <a className="Person-hyperlink" href={`tel:${phone}`}>
              <i className="Contact-method Contact-method__phone"></i> {phoneDisplay}
            </a>
          </p>
          <p className="Person-paragraph Paragraph">
            <a className="Person-hyperlink" href={`mailto:${email}`}>
              <i className="Contact-method Contact-method__email"></i> {email}
            </a>
          </p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/person/index.js